var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _mask, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _rect, _path197, _path198, _path199, _path200, _path201;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    className: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "excelente ubicacion",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 10.3333C20.6667 14.9357 12.3333 22.8333 12.3333 22.8333C12.3333 22.8333 4 14.9357 4 10.3333C4 5.73096 7.73096 2 12.3333 2C16.9357 2 20.6667 5.73096 20.6667 10.3333Z",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 11.3749C13.4839 11.3749 14.4167 10.4422 14.4167 9.29159C14.4167 8.14099 13.4839 7.20825 12.3333 7.20825C11.1827 7.20825 10.25 8.14099 10.25 9.29159C10.25 10.4422 11.1827 11.3749 12.3333 11.3749Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "recepcion de paquetes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 7.56135L21.75 17.2719C21.75 17.4898 21.6319 17.6906 21.4414 17.7964L12.6664 22.6714C12.4852 22.7721 12.2648 22.7721 12.0836 22.6714L3.30861 17.7964C3.11813 17.6906 3 17.4898 3 17.2719L2.99998 7.56136C2.99998 7.34346 3.11811 7.14268 3.30859 7.03686L12.0836 2.16186C12.2648 2.06119 12.4852 2.06119 12.6664 2.16186L21.4414 7.03686C21.6318 7.14268 21.75 7.34345 21.75 7.56135Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5498 7.5142L12.083 12.2548C12.2642 12.3555 12.4845 12.3555 12.6658 12.2548L21.2285 7.49774",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 21.7917L12.375 12.4167",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "wi-fi",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9867 13.9323C14.8886 12.9953 13.4704 12.4777 12.0012 12.4777C10.5319 12.4777 9.11377 12.9953 8.01562 13.9323",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1697 10.8765C17.2251 9.1309 14.6622 8.15979 11.9999 8.15979C9.33758 8.15979 6.7747 9.1309 4.83008 10.8765",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.49967C19.2477 5.1426 15.6883 3.83997 12 3.83997C8.3117 3.83997 4.7523 5.1426 2 7.49967",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 19.2145C11.67 19.2145 11.3471 19.1204 11.0724 18.9442C10.7977 18.768 10.5836 18.5176 10.4572 18.2246C10.3308 17.9316 10.2977 17.6092 10.3622 17.2981C10.4266 16.9871 10.5857 16.7014 10.8193 16.4771C11.0529 16.2529 11.3505 16.1001 11.6745 16.0383C11.9986 15.9764 12.3344 16.0081 12.6396 16.1295C12.9448 16.2509 13.2057 16.4564 13.3892 16.7201C13.5728 16.9838 13.6707 17.2938 13.6707 17.611C13.6707 18.0362 13.4948 18.4441 13.1815 18.7448C12.8683 19.0455 12.4434 19.2145 12.0004 19.2145Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "wi-fi gratuito",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9867 13.9323C14.8886 12.9953 13.4704 12.4777 12.0012 12.4777C10.5319 12.4777 9.11377 12.9953 8.01562 13.9323",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1697 10.8765C17.2251 9.1309 14.6622 8.15979 11.9999 8.15979C9.33758 8.15979 6.7747 9.1309 4.83008 10.8765",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.49967C19.2477 5.1426 15.6883 3.83997 12 3.83997C8.3117 3.83997 4.7523 5.1426 2 7.49967",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 19.2145C11.67 19.2145 11.3471 19.1204 11.0724 18.9442C10.7977 18.768 10.5836 18.5176 10.4572 18.2246C10.3308 17.9316 10.2977 17.6092 10.3622 17.2981C10.4266 16.9871 10.5857 16.7014 10.8193 16.4771C11.0529 16.2529 11.3505 16.1001 11.6745 16.0383C11.9986 15.9764 12.3344 16.0081 12.6396 16.1295C12.9448 16.2509 13.2057 16.4564 13.3892 16.7201C13.5728 16.9838 13.6707 17.2938 13.6707 17.611C13.6707 18.0362 13.4948 18.4441 13.1815 18.7448C12.8683 19.0455 12.4434 19.2145 12.0004 19.2145Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "gimnasio",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76293 8H5.32656C4.99519 8 4.72656 8.26863 4.72656 8.6V16.4909C4.72656 16.8223 4.99519 17.0909 5.32656 17.0909H7.76293C8.0943 17.0909 8.36293 16.8223 8.36293 16.4909V8.6C8.36293 8.26863 8.0943 8 7.76293 8Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6731 8H16.2367C15.9053 8 15.6367 8.26863 15.6367 8.6V16.4909C15.6367 16.8223 15.9053 17.0909 16.2367 17.0909H18.6731C19.0045 17.0909 19.2731 16.8223 19.2731 16.4909V8.6C19.2731 8.26863 19.0045 8 18.6731 8Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.6728V10.4182C2 10.0869 2.26863 9.81824 2.6 9.81824H4.12727C4.45864 9.81824 4.72727 10.0869 4.72727 10.4182V14.6728C4.72727 15.0042 4.45864 15.2728 4.12727 15.2728H2.6C2.26863 15.2728 2 15.0042 2 14.6728Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.6728V10.4182C22 10.0869 21.7314 9.81824 21.4 9.81824H19.8727C19.5414 9.81824 19.2727 10.0869 19.2727 10.4182V14.6728C19.2727 15.0042 19.5414 15.2728 19.8727 15.2728H21.4C21.7314 15.2728 22 15.0042 22 14.6728Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36328 12.5454H15.636",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "sala de eventos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02344 13.0711V11.6514C8.02344 9.43382 9.82115 7.63611 12.0387 7.63611V7.63611C14.2563 7.63611 16.054 9.43382 16.054 11.6514V13.0711",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66797 13.0697V12.3497C2.66797 10.8713 3.86644 9.67285 5.34483 9.67285V9.67285",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4082 13.0697V12.3497C21.4082 10.8713 20.2097 9.67285 18.7313 9.67285V9.67285",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0362 7.6356C13.5146 7.6356 14.7131 6.57103 14.7131 5.2578C14.7131 3.94458 13.5146 2.88 12.0362 2.88C10.5578 2.88 9.35938 3.94458 9.35938 5.2578C9.35938 6.57103 10.5578 7.6356 12.0362 7.6356Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68281 9.67322C6.6068 9.67322 7.35585 8.91281 7.35585 7.97479C7.35585 7.03678 6.6068 6.27637 5.68281 6.27637C4.75881 6.27637 4.00977 7.03678 4.00977 7.97479C4.00977 8.91281 4.75881 9.67322 5.68281 9.67322Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0656 9.67322C19.9896 9.67322 20.7387 8.91281 20.7387 7.97479C20.7387 7.03678 19.9896 6.27637 19.0656 6.27637C18.1416 6.27637 17.3926 7.03678 17.3926 7.97479C17.3926 8.91281 18.1416 9.67322 19.0656 9.67322Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_4047_2437",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 15.1932C2 14.7711 2.34219 14.429 2.76429 14.429H21.3122C21.7343 14.429 22.0765 14.7711 22.0765 15.1932C22.0765 18.148 19.6812 20.5433 16.7264 20.5433H7.35005C4.3953 20.5433 2 18.148 2 15.1932Z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.1932C2 14.7711 2.34219 14.429 2.76429 14.429H21.3122C21.7343 14.429 22.0765 14.7711 22.0765 15.1932C22.0765 18.148 19.6812 20.5433 16.7264 20.5433H7.35005C4.3953 20.5433 2 18.148 2 15.1932Z",
    strokeWidth: 2,
    mask: "url(#path-7-inside-1_4047_2437)"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "terraza",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9739 15.3092L14.7042 16.9292L9.71484 20.9207",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65234 15.3092L10 17L14.5 21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12V21",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17V21",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17L17 17",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19L17 19",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12V21",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17V21",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17L8 17",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19L8 19",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32178 15.3091L16.3047 15.3091",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17H14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4881 6.02458C16.1061 4.71895 14.2684 4 12.3138 4C10.3591 4 8.52144 4.71906 7.1393 6.02458C5.75728 7.33031 4.99609 9.0662 4.99609 10.9126C4.99609 11.1363 5.18804 11.3177 5.42476 11.3177C5.66159 11.3177 5.85353 11.1363 5.85353 10.9126C5.85353 10.2389 6.43383 9.69074 7.14701 9.69074C8.40595 9.69074 7.94404 11.3177 8.86926 11.3177C9.79448 11.3177 9.33261 9.69074 10.5915 9.69074C11.8504 9.69074 12.3138 11.3177 12.3138 11.3177C12.3138 11.3177 12.7771 9.69074 14.036 9.69074C15.2949 9.69074 14.9667 11.3177 15.7583 11.3177C16.5498 11.3177 16.2216 9.69074 17.4805 9.69074C18.1937 9.69074 18.774 10.2389 18.774 10.9126C18.774 11.1363 18.9659 11.3177 19.2028 11.3177C19.4395 11.3177 19.6314 11.1363 19.6314 10.9126C19.6314 9.0662 18.8703 7.33031 17.4881 6.02458Z",
    strokeWidth: 1.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3125 11.3176C12.3125 11.3176 12.3125 12.8034 12.3125 14.2205M12.3125 14.2205C12.3125 15.6719 12.3125 15.6719 12.3125 14.2205Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "dog friendly",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1655 8.77546C21.0055 8.71252 20.835 8.68044 20.663 8.68091H20.645C19.737 8.69442 18.7186 9.54486 18.1842 10.8311C17.5436 12.3699 17.8384 13.9443 18.8478 14.349C19.0077 14.4119 19.178 14.444 19.3498 14.4436C20.2623 14.4436 21.2947 13.5882 21.8336 12.2934C22.4697 10.7546 22.1703 9.18019 21.1655 8.77546Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3054 14.7802C14.054 12.7037 13.5138 11.9227 12.0824 11.9227C10.6509 11.9227 10.1062 12.7087 8.85485 14.7802C7.78351 16.552 5.61832 16.6996 5.07815 18.2045C4.96857 18.4801 4.91353 18.7744 4.9161 19.071C4.9161 20.2949 5.8524 21.2857 7.00476 21.2857C8.43621 21.2857 10.3853 20.1428 12.0869 20.1428C13.7884 20.1428 15.7285 21.2857 17.16 21.2857C18.3123 21.2857 19.2441 20.2954 19.2441 19.071C19.2452 18.7741 19.1886 18.4798 19.0776 18.2045C18.5374 16.6942 16.3767 16.552 15.3054 14.7802Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22624 9.94273C9.28652 9.94278 9.34672 9.93826 9.40632 9.92922C10.4513 9.7775 11.1036 8.32964 10.8668 6.69449C10.6439 5.15298 9.70841 4 8.73011 4C8.66983 3.99995 8.60963 4.00447 8.55003 4.01351C7.5051 4.16523 6.85275 5.61309 7.08956 7.24824C7.31241 8.78525 8.24794 9.94273 9.22624 9.94273Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0764 7.24836C17.3132 5.61321 16.6608 4.16535 15.6159 4.01363C15.5563 4.00459 15.4961 4.00007 15.4358 4.00012C14.4575 4.00012 13.5238 5.1531 13.3005 6.69461C13.0637 8.32976 13.716 9.77762 14.761 9.92934C14.8206 9.93838 14.8808 9.9429 14.9411 9.94285C15.9193 9.94285 16.8549 8.78537 17.0764 7.24836Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32109 14.3494C6.3291 13.9442 6.62354 12.3685 5.98379 10.8315C5.44535 9.53667 4.41392 8.68128 3.50271 8.68128C3.33091 8.68081 3.16058 8.71289 3.00073 8.77582C1.99271 9.18101 1.69828 10.7567 2.33802 12.2937C2.87647 13.5885 3.90789 14.4439 4.81911 14.4439C4.99091 14.4444 5.16124 14.4123 5.32109 14.3494V14.3494Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "centro de internet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1 14.6111V5C4.1 3.89543 4.99543 3 6.1 3H18.9C20.0046 3 20.9 3.89543 20.9 5V14.6111M4.1 14.6111H20.9M4.1 14.6111L2.72382 19.4532C2.36087 20.7303 3.32003 22 4.64763 22H20.3524C21.68 22 22.6391 20.7303 22.2762 19.4532L20.9 14.6111",
    strokeWidth: 1.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19L13 19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "spa",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11H5C3.89543 11 3 10.1046 3 9V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M18 21L18 17",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3V7V11V21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7H3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "sauna",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19V3H19V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19Z",
    strokeWidth: 1.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6H3.5C2.67157 6 2 5.32843 2 4.5V4.5C2 3.67157 2.67157 3 3.5 3H20.5C21.3284 3 22 3.67157 22 4.5V4.5C22 5.32843 21.3284 6 20.5 6H19",
    strokeWidth: 1.5
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3L15 21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "cambio de divisas",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04806 3.35868C6.05869 2.53179 5.06325 2.51347 3.87746 3.08345C2.37799 3.80419 1.75203 5.56052 2.38407 7.12027",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06169 3.98357L6.90306 3.57914C7.20172 3.43559 7.3196 3.08103 7.16637 2.78722L6.73761 1.96516",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0879 18.4202C16.2186 19.2273 17.3563 19.2451 18.7115 18.6889C20.4252 17.9854 21.1405 16.2713 20.4182 14.749",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2163 17.8102L15.1918 18.2307C14.8852 18.3566 14.7768 18.6878 14.9495 18.9706L15.4438 19.7801",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8413 14.749C18.2679 14.749 21.0458 12.0823 21.0458 8.79267C21.0458 5.50306 18.2679 2.8363 14.8413 2.8363C11.4146 2.8363 8.63672 5.50306 8.63672 8.79267C8.63672 12.0823 11.4146 14.749 14.8413 14.749Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2718 9.77956C16.2718 8.29929 13.6468 9.03942 13.6468 7.55915C13.6468 6.81521 14.129 6.50746 14.6996 6.47932C14.7459 6.47703 14.7928 6.47659 14.84 6.47791L14.6996 6.47932C14.129 6.50746 13.6468 6.81521 13.6468 7.55915C13.6468 9.03942 16.2718 8.29929 16.2718 9.77956C16.2718 10.5969 15.617 10.963 14.9099 10.9608C14.8867 10.9607 14.8634 10.9602 14.84 10.9593L14.9099 10.9608C15.617 10.963 16.2718 10.5969 16.2718 9.77956Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2718 7.06571C15.9449 6.72772 15.3692 6.49263 14.84 6.47791M13.4082 10.273C13.7158 10.697 14.2877 10.9388 14.84 10.9593M14.84 6.47791C14.2104 6.46039 13.6468 6.75485 13.6468 7.55915C13.6468 9.03942 16.2718 8.29929 16.2718 9.77956C16.2718 10.6238 15.5732 10.9866 14.84 10.9593M14.84 6.47791L14.6992 6.47932M14.84 10.9593L14.91 10.9608",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15962 20.2472C11.5863 20.2472 14.3642 17.5804 14.3642 14.2908C14.3642 11.0012 11.5863 8.33447 8.15962 8.33447C4.73295 8.33447 1.95508 11.0012 1.95508 14.2908C1.95508 17.5804 4.73295 20.2472 8.15962 20.2472Z",
    fill: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5902 12.5639C9.26327 12.2259 8.68752 11.9908 8.15838 11.9761M6.72656 15.7712C7.03416 16.1952 7.60607 16.437 8.15838 16.4575M8.15838 11.9761C7.5288 11.9586 6.9652 12.253 6.9652 13.0573C6.9652 14.5376 9.5902 13.7975 9.5902 15.2777C9.5902 16.122 8.89155 16.4848 8.15838 16.4575M8.15838 11.9761V11.0836M8.15838 16.4575V17.4982",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "cambio de monedas",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04806 3.35868C6.05869 2.53179 5.06325 2.51347 3.87746 3.08345C2.37799 3.80419 1.75203 5.56052 2.38407 7.12027",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06169 3.98357L6.90306 3.57914C7.20172 3.43559 7.3196 3.08103 7.16637 2.78722L6.73761 1.96516",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0879 18.4202C16.2186 19.2273 17.3563 19.2451 18.7115 18.6889C20.4252 17.9854 21.1405 16.2713 20.4182 14.749",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2163 17.8102L15.1918 18.2307C14.8852 18.3566 14.7768 18.6878 14.9495 18.9706L15.4438 19.7801",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8413 14.749C18.2679 14.749 21.0458 12.0823 21.0458 8.79267C21.0458 5.50306 18.2679 2.8363 14.8413 2.8363C11.4146 2.8363 8.63672 5.50306 8.63672 8.79267C8.63672 12.0823 11.4146 14.749 14.8413 14.749Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2718 9.77956C16.2718 8.29929 13.6468 9.03942 13.6468 7.55915C13.6468 6.81521 14.129 6.50746 14.6996 6.47932C14.7459 6.47703 14.7928 6.47659 14.84 6.47791L14.6996 6.47932C14.129 6.50746 13.6468 6.81521 13.6468 7.55915C13.6468 9.03942 16.2718 8.29929 16.2718 9.77956C16.2718 10.5969 15.617 10.963 14.9099 10.9608C14.8867 10.9607 14.8634 10.9602 14.84 10.9593L14.9099 10.9608C15.617 10.963 16.2718 10.5969 16.2718 9.77956Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2718 7.06571C15.9449 6.72772 15.3692 6.49263 14.84 6.47791M13.4082 10.273C13.7158 10.697 14.2877 10.9388 14.84 10.9593M14.84 6.47791C14.2104 6.46039 13.6468 6.75485 13.6468 7.55915C13.6468 9.03942 16.2718 8.29929 16.2718 9.77956C16.2718 10.6238 15.5732 10.9866 14.84 10.9593M14.84 6.47791L14.6992 6.47932M14.84 10.9593L14.91 10.9608",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15962 20.2472C11.5863 20.2472 14.3642 17.5804 14.3642 14.2908C14.3642 11.0012 11.5863 8.33447 8.15962 8.33447C4.73295 8.33447 1.95508 11.0012 1.95508 14.2908C1.95508 17.5804 4.73295 20.2472 8.15962 20.2472Z",
    fill: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5902 12.5639C9.26327 12.2259 8.68752 11.9908 8.15838 11.9761M6.72656 15.7712C7.03416 16.1952 7.60607 16.437 8.15838 16.4575M8.15838 11.9761C7.5288 11.9586 6.9652 12.253 6.9652 13.0573C6.9652 14.5376 9.5902 13.7975 9.5902 15.2777C9.5902 16.122 8.89155 16.4848 8.15838 16.4575M8.15838 11.9761V11.0836M8.15838 16.4575V17.4982",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "servicio de despertador",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.48H12V7.67998",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.35999L7 1.91999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.35999L17 1.91999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.1201C16.9706 21.1201 21 17.2518 21 12.4801C21 7.70835 16.9706 3.84009 12 3.84009C7.02944 3.84009 3 7.70835 3 12.4801C3 17.2518 7.02944 21.1201 12 21.1201Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "bar",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4116 15.7059L3 7.23535H17.8233L10.4116 15.7059Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4121 15.7061V19.9413",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23438 21H13.5872",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17578 10.4116L14.6462 10.4116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5304 9.4452L17.8529 9.39348C19.3136 9.33634 20.4515 8.1058 20.3944 6.64499C20.3373 5.18417 19.1067 4.04627 17.6459 4.1034C16.1852 4.16054 15.0473 5.39108 15.1044 6.85189M15.1044 6.85189C15.1103 7.00209 15.0747 6.70947 15.1044 6.85189Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "piscina al aire libre",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0646 7L13.0352 3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0685 7L11.0391 3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0607 21L13.0312 17",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0646 21L11.0352 17",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01996 13.0779L7.01953 13.0122",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00043 11.0827L7 11.0171",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0138 13.1828L20 13.1172",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 11.0827L19.9863 11.0171",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "room service",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.71429C4 4.76749 4.67158 4 5.5 4H18.5C19.3285 4 20 4.76749 20 5.71429V12H4V5.71429Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18V20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18V20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9H6.5C5.67155 9 5 9.80586 5 10.8V12H11V10.8C11 9.80586 10.3285 9 9.5 9Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9H13.5C12.6715 9 12 9.80586 12 10.8V12H18V10.8C18 9.80586 17.3285 9 16.5 9Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.5C2 12.6715 2.67158 12 3.5 12H20.5C21.3285 12 22 12.6715 22 13.5V18H2V13.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "estacionamiento",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55547 15.9954C7.2182 15.9954 7.75547 15.4357 7.75547 14.7454C7.75547 14.055 7.2182 13.4954 6.55547 13.4954C5.89273 13.4954 5.35547 14.055 5.35547 14.7454C5.35547 15.4357 5.89273 15.9954 6.55547 15.9954Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6434 15.9954C17.3061 15.9954 17.8434 15.4357 17.8434 14.7454C17.8434 14.055 17.3061 13.4954 16.6434 13.4954C15.9806 13.4954 15.4434 14.055 15.4434 14.7454C15.4434 15.4357 15.9806 15.9954 16.6434 15.9954Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44 18.5C2.64471 18.5 2 17.8285 2 17V12.3548C2 11.2181 2.61673 10.179 3.59293 9.6711L3.92025 9.50075L5.02904 4.54597C5.23165 3.64058 6.00642 3 6.89888 3H16.3493C17.2484 3 18.0272 3.64999 18.2231 4.56408L19.2815 9.50075L19.608 9.6708C20.5837 10.179 21.2 11.2177 21.2 12.354V17C21.2 17.8285 20.5553 18.5 19.76 18.5H18.8015V19C18.8015 20.1046 17.9411 21 16.8808 21C15.8204 21 14.96 20.1046 14.96 19V18.5H8.24V19.0002C8.24 20.1047 7.38046 21 6.32014 21C5.25982 21 4.40025 20.1047 4.40025 19.0002V18.5H3.44Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80078 10.9968H16.4008L15.6078 7.27988C15.5102 6.82238 15.1207 6.49683 14.6707 6.49683H8.53085C8.08089 6.49683 7.69133 6.82238 7.59374 7.27988L6.80078 10.9968Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "servicio de traslado",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55547 15.9954C7.2182 15.9954 7.75547 15.4357 7.75547 14.7454C7.75547 14.055 7.2182 13.4954 6.55547 13.4954C5.89273 13.4954 5.35547 14.055 5.35547 14.7454C5.35547 15.4357 5.89273 15.9954 6.55547 15.9954Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6434 15.9954C17.3061 15.9954 17.8434 15.4357 17.8434 14.7454C17.8434 14.055 17.3061 13.4954 16.6434 13.4954C15.9806 13.4954 15.4434 14.055 15.4434 14.7454C15.4434 15.4357 15.9806 15.9954 16.6434 15.9954Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44 18.5C2.64471 18.5 2 17.8285 2 17V12.3548C2 11.2181 2.61673 10.179 3.59293 9.6711L3.92025 9.50075L5.02904 4.54597C5.23165 3.64058 6.00642 3 6.89888 3H16.3493C17.2484 3 18.0272 3.64999 18.2231 4.56408L19.2815 9.50075L19.608 9.6708C20.5837 10.179 21.2 11.2177 21.2 12.354V17C21.2 17.8285 20.5553 18.5 19.76 18.5H18.8015V19C18.8015 20.1046 17.9411 21 16.8808 21C15.8204 21 14.96 20.1046 14.96 19V18.5H8.24V19.0002C8.24 20.1047 7.38046 21 6.32014 21C5.25982 21 4.40025 20.1047 4.40025 19.0002V18.5H3.44Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80078 10.9968H16.4008L15.6078 7.27988C15.5102 6.82238 15.1207 6.49683 14.6707 6.49683H8.53085C8.08089 6.49683 7.69133 6.82238 7.59374 7.27988L6.80078 10.9968Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "servicio de traslado gratuito",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55547 15.9954C7.2182 15.9954 7.75547 15.4357 7.75547 14.7454C7.75547 14.055 7.2182 13.4954 6.55547 13.4954C5.89273 13.4954 5.35547 14.055 5.35547 14.7454C5.35547 15.4357 5.89273 15.9954 6.55547 15.9954Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6434 15.9954C17.3061 15.9954 17.8434 15.4357 17.8434 14.7454C17.8434 14.055 17.3061 13.4954 16.6434 13.4954C15.9806 13.4954 15.4434 14.055 15.4434 14.7454C15.4434 15.4357 15.9806 15.9954 16.6434 15.9954Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44 18.5C2.64471 18.5 2 17.8285 2 17V12.3548C2 11.2181 2.61673 10.179 3.59293 9.6711L3.92025 9.50075L5.02904 4.54597C5.23165 3.64058 6.00642 3 6.89888 3H16.3493C17.2484 3 18.0272 3.64999 18.2231 4.56408L19.2815 9.50075L19.608 9.6708C20.5837 10.179 21.2 11.2177 21.2 12.354V17C21.2 17.8285 20.5553 18.5 19.76 18.5H18.8015V19C18.8015 20.1046 17.9411 21 16.8808 21C15.8204 21 14.96 20.1046 14.96 19V18.5H8.24V19.0002C8.24 20.1047 7.38046 21 6.32014 21C5.25982 21 4.40025 20.1047 4.40025 19.0002V18.5H3.44Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80078 10.9968H16.4008L15.6078 7.27988C15.5102 6.82238 15.1207 6.49683 14.6707 6.49683H8.53085C8.08089 6.49683 7.69133 6.82238 7.59374 7.27988L6.80078 10.9968Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "servicio m\\xE9dico",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3857 6.46057H4.84628C3.82661 6.46057 3 7.28718 3 8.30686V18.1537C3 19.1734 3.82661 20 4.84628 20H18.3857C19.4054 20 20.232 19.1734 20.232 18.1537V8.30686C20.232 7.28718 19.4054 6.46057 18.3857 6.46057Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30664 6.46171V5.23086C7.30664 4.90441 7.43632 4.59134 7.66715 4.36051C7.89798 4.12968 8.21105 4 8.5375 4H14.6918C15.0182 4 15.3313 4.12968 15.5621 4.36051C15.793 4.59134 15.9226 4.90441 15.9226 5.23086V6.46171",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6172 10.1545V16.3097",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6942 13.2306H8.53906",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "lavado / planchado",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.2H22L21 11.52H10C5.5817 11.52 2 14.9585 2 19.2Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.83997H20L21 11.52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.36H9.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "lavanderia",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.2H22L21 11.52H10C5.5817 11.52 2 14.9585 2 19.2Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.83997H20L21 11.52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.36H9.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "guarda equipaje",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 4L3 7.4V19.3C3 19.7509 3.19901 20.1833 3.55324 20.5021C3.90748 20.8209 4.38792 21 4.88889 21H18.1111C18.6121 21 19.0925 20.8209 19.4468 20.5021C19.801 20.1833 20 19.7509 20 19.3V7.4L17.1667 4H5.83333Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.57642H20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.1576C15 11.8695 14.6313 12.5522 13.9749 13.0556C13.3185 13.559 12.4283 13.8418 11.5 13.8418C10.5717 13.8418 9.6815 13.559 9.02513 13.0556C8.36875 12.5522 8 11.8695 8 11.1576",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "caja de seguridad",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 10V8C17.625 5.23858 15.1066 3 12 3C8.8934 3 6.375 5.23858 6.375 8V10M12 14.5V16.5M8.4 21H15.6C17.4902 21 18.4353 21 19.1572 20.673C19.7923 20.3854 20.3086 19.9265 20.6321 19.362C21 18.7202 21 17.8802 21 16.2V14.8C21 13.1198 21 12.2798 20.6321 11.638C20.3086 11.0735 19.7923 10.6146 19.1572 10.327C18.4353 10 17.4902 10 15.6 10H8.4C6.50982 10 5.56473 10 4.84278 10.327C4.20774 10.6146 3.69143 11.0735 3.36785 11.638C3 12.2798 3 13.1198 3 14.8V16.2C3 17.8802 3 18.7202 3.36785 19.362C3.69143 19.9265 4.20774 20.3854 4.84278 20.673C5.56473 21 6.50982 21 8.4 21Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "desayuno",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5566 9.48889V14C17.5566 17.3137 14.8703 20 11.5566 20H8.00084C4.68713 20 2.00084 17.3137 2.00084 14V9.48889C2.00084 9.15752 2.26947 8.88889 2.60084 8.88889H16.9566C17.288 8.88889 17.5566 9.15752 17.5566 9.48889Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5239 8C11.5239 7.09091 12.3402 6.18182 13.9729 6.18182C14.0577 6.18182 14.1464 6.18182 14.238 6.18182C15.8948 6.18182 17.2383 4.83867 17.2383 3.18182V3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76219 8V7.5C6.76219 5.84315 8.10533 4.5 9.76219 4.5H10.4766C11.5811 4.5 12.4766 3.60457 12.4766 2.5V2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4453 8.88892H19.2231C20.7573 8.88892 22.001 10.1326 22.001 11.6667C22.001 13.2008 20.7573 14.4445 19.2231 14.4445H17.5564",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "desayuno gratuito",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5566 9.48889V14C17.5566 17.3137 14.8703 20 11.5566 20H8.00084C4.68713 20 2.00084 17.3137 2.00084 14V9.48889C2.00084 9.15752 2.26947 8.88889 2.60084 8.88889H16.9566C17.288 8.88889 17.5566 9.15752 17.5566 9.48889Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5239 8C11.5239 7.09091 12.3402 6.18182 13.9729 6.18182C14.0577 6.18182 14.1464 6.18182 14.238 6.18182C15.8948 6.18182 17.2383 4.83867 17.2383 3.18182V3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76219 8V7.5C6.76219 5.84315 8.10533 4.5 9.76219 4.5H10.4766C11.5811 4.5 12.4766 3.60457 12.4766 2.5V2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4453 8.88892H19.2231C20.7573 8.88892 22.001 10.1326 22.001 11.6667C22.001 13.2008 20.7573 14.4445 19.2231 14.4445H17.5564",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "peluqueria",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.6L22 17M22 7L5.5 15.4M7 3C8.65685 3 10 4.34315 10 6C10 7.65685 8.65685 9 7 9C5.34315 9 4 7.65685 4 6C4 4.34315 5.34315 3 7 3ZM7 15C8.65685 15 10 16.3431 10 18C10 19.6569 8.65685 21 7 21C5.34315 21 4 19.6569 4 18C4 16.3431 5.34315 15 7 15Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "rampas para discapacitados",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M15.263 7.2353C16.5225 7.2353 17.5435 6.2872 17.5435 5.11765C17.5435 3.94811 16.5225 3 15.263 3C14.0035 3 12.9824 3.94811 12.9824 5.11765C12.9824 6.2872 14.0035 7.2353 15.263 7.2353Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8424 14.6472L12.4126 10.9413L12.6719 9.35303L7.07422 10.4623L8.94012 12.6808",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5526 15.706L15.2626 11.4707L15.8331 9.35303H12.9821L12.4119 10.4119L11.8418 14.1177",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1211 15.7058H17.5419L18.6822 20.4705",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99096 21.0002C11.1951 21.0002 12.9819 19.341 12.9819 17.2943C12.9819 15.2476 11.1951 13.5884 8.99096 13.5884C6.78681 13.5884 5 15.2476 5 17.2943C5 19.341 6.78681 21.0002 8.99096 21.0002Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "union Pay",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.1429V17C21 18.1046 20.1046 19 19 19H7C5.89543 19 5 18.1046 5 17V16.5M21 11.1429V10C21 8.89543 20.1046 8 19 8H18.1765M21 11.1429H18.1765",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.5V14C18 15.1046 17.1046 16 16 16H4C2.89543 16 2 15.1046 2 14V6C2 4.89543 2.89543 4 4 4H16C17.1046 4 18 4.89543 18 6V7.5ZM18 7.5H5.29412",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "piscina para ni\\xF1os",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16C5.48276 16 7.34483 13 7.34483 13C7.34483 13 9.2069 16 11.6897 16C14.1724 16 16.6552 13 16.6552 13C16.6552 13 19.1379 16 21 16",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21C5.48276 21 7.34483 18 7.34483 18C7.34483 18 9.2069 21 11.6897 21C14.1724 21 16.6552 18 16.6552 18C16.6552 18 19.1379 21 21 21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.5L9 9L7.81306 7.51633C7.36819 6.96024 7.47151 6.14637 8.04123 5.71908V5.71908C8.57851 5.31612 9.33729 5.40475 9.76724 5.92069L14 11",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9C17.8807 9 19 7.88071 19 6.5C19 5.11929 17.8807 4 16.5 4C15.1193 4 14 5.11929 14 6.5C14 7.88071 15.1193 9 16.5 9Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "piscina",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16C5.48276 16 7.34483 13 7.34483 13C7.34483 13 9.2069 16 11.6897 16C14.1724 16 16.6552 13 16.6552 13C16.6552 13 19.1379 16 21 16",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21C5.48276 21 7.34483 18 7.34483 18C7.34483 18 9.2069 21 11.6897 21C14.1724 21 16.6552 18 16.6552 18C16.6552 18 19.1379 21 21 21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.5L9 9L7.81306 7.51633C7.36819 6.96024 7.47151 6.14637 8.04123 5.71908V5.71908C8.57851 5.31612 9.33729 5.40475 9.76724 5.92069L14 11",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9C17.8807 9 19 7.88071 19 6.5C19 5.11929 17.8807 4 16.5 4C15.1193 4 14 5.11929 14 6.5C14 7.88071 15.1193 9 16.5 9Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "jardines",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.0001L12 14.4001M12 10.6001L12 14.4001M12 14.4001L15.6 12.5001",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.75C16.5 5.12665 14.4853 3 12 3C9.51472 3 7.5 5.12665 7.5 7.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.2H7.95C5.21619 18.2 3 15.8607 3 12.975C3 10.0893 5.21619 7.75 7.95 7.75H9.3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.1999H16.05C18.7838 18.1999 21 15.8606 21 12.9749C21 10.2494 19.0229 8.01122 16.5 7.77124",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "cajero autom\\xE1tico",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11L4.80662 7.84255C5.5657 6.98859 6.65372 6.5 7.79627 6.5L8 6.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.5003L7.5 19.5L11.5 16.5003C11.5 16.5003 12.3091 15.9528 13.5 15.0001C16 13.0002 13.5 9.83352 11 11.4997C8.96409 12.8565 7 14.0003 7 14.0003",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5V7C8 5.89543 8.89543 5 10 5H20C21.1046 5 22 5.89543 22 7V13C22 14.1046 21.1046 15 20 15H13.5",
    strokeWidth: 1.5
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12C13.8954 12 13 11.1046 13 10C13 8.89543 13.8954 8 15 8C16.1046 8 17 8.89543 17 10C17 11.1046 16.1046 12 15 12Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.01L19.51 9.99889",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.01L10.51 9.99889",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "restaurante/bar",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30273 20.0222H8.79115M12.2796 20.0222H8.79115M8.79115 20.0222V14.5312",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0938 20.0222V11.2366C18.0938 11.2366 21.0008 10.1384 21.0008 7.94196C21.0008 6.01201 21.0008 3.00003 21.0008 3.00003",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0938 7.39282V3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5579 10.1384C4.72062 12.4755 8.79052 14.5312 8.79052 14.5312C8.79052 14.5312 12.8604 12.4755 14.0231 10.1384C15.2784 7.61538 14.0231 3.00009 14.0231 3.00009L3.5579 3.00009C3.5579 3.00009 2.30263 7.61538 3.5579 10.1384Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "restaurante",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13866 3.521L19.5852 18.5202C19.8972 18.8048 20.0725 19.1909 20.0725 19.5934C20.0725 19.9959 19.8972 20.3819 19.5852 20.6665V20.6665C19.273 20.951 18.8498 21.1108 18.4085 21.1108C17.9672 21.1108 17.5439 20.951 17.2318 20.6665L13.2142 16.9394C12.9513 16.6959 12.8038 16.368 12.8035 16.0262V15.8011C12.8036 15.6286 12.766 15.4577 12.6931 15.2985C12.6201 15.1393 12.5132 14.9949 12.3786 14.8737L11.8599 14.4369C11.6838 14.2887 11.4696 14.1833 11.2372 14.1304C11.0047 14.0774 10.7614 14.0787 10.5296 14.134V14.134C10.1641 14.221 9.77997 14.2193 9.41538 14.1291C9.05079 14.0389 8.7184 13.8633 8.4512 13.6198L4.63765 10.1414C2.37532 8.0782 1.5428 4.96258 3.13866 3.521Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4281 2.87988L14.9792 6.02527C14.7138 6.26726 14.5033 6.55456 14.3596 6.87075C14.216 7.18695 14.1421 7.52586 14.1421 7.86812V8.47317C14.1421 8.55878 14.1236 8.64355 14.0877 8.72264C14.0517 8.80172 13.9991 8.87358 13.9327 8.93409L13.4277 9.3946",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8574 10.6968L15.3624 10.2363C15.4287 10.1757 15.5075 10.1277 15.5942 10.0949C15.6809 10.0621 15.7739 10.0453 15.8678 10.0453H16.5312C16.9065 10.0453 17.2781 9.97789 17.6248 9.84689C17.9715 9.7159 18.2865 9.5239 18.5519 9.28186L22.0008 6.13647",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2164 4.50879L16.6426 7.76808",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50011 16.5591L5.04803 20.6422C4.71314 20.9475 4.25899 21.1191 3.78545 21.1191C3.31191 21.1191 2.85776 20.9475 2.52287 20.6422V20.6422C2.18808 20.3368 2 19.9226 2 19.4907C2 19.0589 2.18808 18.6447 2.52287 18.3392L6.28562 14.9304",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "tel\\xE9fono",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7686 5.41282C14.6571 5.57922 15.4736 5.99635 16.1136 6.61082C16.7537 7.22529 17.1882 8.00914 17.3616 8.86205M13.7686 1.91992C15.6145 2.11678 17.3357 2.91031 18.6498 4.17023C19.9639 5.43014 20.7926 7.08156 21 8.85332M20.0904 15.8216V18.4413C20.0914 18.6845 20.0395 18.9252 19.938 19.1481C19.8366 19.3709 19.6877 19.5709 19.501 19.7353C19.3144 19.8997 19.094 20.0249 18.854 20.1028C18.614 20.1807 18.3597 20.2097 18.1074 20.1878C15.3084 19.8958 12.6198 18.9776 10.2575 17.507C8.05976 16.1663 6.19643 14.3775 4.79988 12.2676C3.26262 9.98956 2.30596 7.3959 2.00738 4.69677C1.98465 4.4553 2.01455 4.21192 2.09516 3.98215C2.17578 3.75237 2.30534 3.54123 2.47562 3.36216C2.64589 3.18309 2.85314 3.04001 3.08417 2.94205C3.3152 2.84408 3.56494 2.79337 3.8175 2.79315H6.54633C6.98777 2.78897 7.41572 2.93904 7.75043 3.21538C8.08514 3.49171 8.30376 3.87546 8.36554 4.29509C8.48072 5.13344 8.69432 5.9566 9.00227 6.74885C9.12465 7.0614 9.15114 7.40107 9.07859 7.72763C9.00604 8.05418 8.83751 8.35393 8.59295 8.59135L7.43774 9.70035C8.73262 11.8865 10.6181 13.6966 12.8954 14.9397L14.0506 13.8307C14.2979 13.5959 14.6101 13.4341 14.9503 13.3645C15.2905 13.2948 15.6443 13.3203 15.9699 13.4377C16.7951 13.7334 17.6526 13.9384 18.5259 14.049C18.9677 14.1088 19.3713 14.3225 19.6597 14.6493C19.9482 14.9762 20.1015 15.3934 20.0904 15.8216Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "ascensor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3L12.5 21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M22 3.6V20.4C22 20.7314 21.7314 21 21.4 21H3.6C3.26863 21 3 20.7314 3 20.4V3.6C3 3.26863 3.26863 3 3.6 3H21.4C21.7314 3 22 3.26863 22 3.6Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16732 12L7.75065 10L9.33398 12",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6673 12L17.2507 14L18.834 12",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "aire acondicionado",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.43988L6.5 9.26388M21 16.5599L17.5 14.7359M12 11.9999L6.5 9.26388M12 11.9999L6.5 14.7359M12 11.9999V5.61588M12 11.9999V17.9279M12 11.9999L17.5 14.7359M12 11.9999L17.5 9.26388M12 2.87988V5.61588M12 21.1199V17.9279M21 7.43988L17.5 9.26388M3 16.5599L6.5 14.7359M6.5 9.26388L3 10.1759M6.5 9.26388L6 6.07188M6.5 14.7359L3 13.8239M6.5 14.7359L6 17.9279M12 5.61588L9.5 4.70388M12 5.61588L14.5 4.70388M12 17.9279L14.5 19.2959M12 17.9279L9.5 19.2959M17.5 14.7359L18 17.9279M17.5 14.7359L21 13.8239M17.5 9.26388L21 10.1759M17.5 9.26388L18 6.07188",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "tiendas",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.6V21M12.5 6.6H9.14107C8.64616 6.6 8.17152 6.41036 7.82156 6.07279C7.4716 5.73523 7.275 5.27739 7.275 4.8C7.275 4.32261 7.4716 3.86477 7.82156 3.52721C8.17152 3.18964 8.64616 3 9.14107 3C11.7536 3 12.5 6.6 12.5 6.6ZM12.5 6.6H15.8589C16.3538 6.6 16.8285 6.41036 17.1784 6.07279C17.5284 5.73523 17.725 5.27739 17.725 4.8C17.725 4.32261 17.5284 3.86477 17.1784 3.52721C16.8285 3.18964 16.3538 3 15.8589 3C13.2464 3 12.5 6.6 12.5 6.6ZM20.1 11.1V18.12C20.1 19.1281 20.1 19.6321 19.8929 20.0172C19.7108 20.3559 19.4201 20.6312 19.0626 20.8038C18.6561 21 18.1241 21 17.06 21L7.94 21C6.8759 21 6.34385 21 5.93742 20.8038C5.57991 20.6312 5.28925 20.3559 5.10709 20.0172C4.9 19.6321 4.9 19.1281 4.9 18.12V11.1M3 8.04L3 9.66C3 10.164 3 10.4161 3.10354 10.6086C3.19462 10.7779 3.33995 10.9156 3.51871 11.0019C3.72193 11.1 3.98795 11.1 4.52 11.1L20.48 11.1C21.0121 11.1 21.2781 11.1 21.4813 11.0019C21.66 10.9156 21.8054 10.7779 21.8965 10.6086C22 10.4161 22 10.164 22 9.66V8.04C22 7.53595 22 7.28393 21.8965 7.09141C21.8054 6.92206 21.66 6.78438 21.4813 6.69809C21.2781 6.6 21.012 6.6 20.48 6.6L4.52 6.6C3.98795 6.6 3.72193 6.6 3.51871 6.69809C3.33996 6.78438 3.19462 6.92206 3.10354 7.09141C3 7.28393 3 7.53595 3 8.04Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "sombrillas",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6563 6.2139C17.145 4.78618 15.1354 4 12.998 4C10.8607 4 8.8511 4.7863 7.33972 6.2139C5.82846 7.64174 4.99609 9.53995 4.99609 11.559C4.99609 11.8037 5.20599 12.002 5.46484 12.002C5.72382 12.002 5.93371 11.8037 5.93371 11.559C5.93371 10.8223 6.56828 10.2229 7.34814 10.2229C8.72481 10.2229 8.2197 12.002 9.23145 12.002C10.2432 12.002 9.73813 10.2229 11.1147 10.2229C12.4914 10.2229 12.998 12.002 12.998 12.002C12.998 12.002 13.5047 10.2229 14.8813 10.2229C16.258 10.2229 15.8991 12.002 16.7646 12.002C17.6302 12.002 17.2713 10.2229 18.6479 10.2229C19.4278 10.2229 20.0624 10.8223 20.0624 11.559C20.0624 11.8037 20.2723 12.002 20.5313 12.002C20.7901 12.002 21 11.8037 21 11.559C21 9.53995 20.1678 7.64174 18.6563 6.2139Z",
    strokeWidth: 1.5
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M12.252 21.3069L12.8619 11.8688M12.8619 11.8688C12.3142 11.4216 12.6698 11.7119 12.8619 11.8688Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "masajes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 16H20.8574",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.5C17.5 6 19 9.54545 19 9.54545V10",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99982 12.9999C7.49976 11.9999 8 9 13.9399 11.0017",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12C7.32843 12 8 11.3284 8 10.5C8 9.67157 7.32843 9 6.5 9C5.67157 9 5 9.67157 5 10.5C5 11.3284 5.67157 12 6.5 12Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57227 12.8182L5.57227 21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13L14 13",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.1819L21 15.9092",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50098 8L11.001 9L13.2863 7.09082L13.7148 9.95446V10.3635",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57227 12.8182L5.57227 21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 10H20.8574",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.9999L18 21.0908",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10L14 15.7273",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6C12.6716 6 12 5.32843 12 4.5C12 3.67157 12.6716 3 13.5 3C14.3284 3 15 3.67157 15 4.5C15 5.32843 14.3284 6 13.5 6Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "alojamiento y desayuno",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7625 7.32353C11.1974 7.32353 11.55 7.67907 11.55 8.11765C11.55 8.55623 11.1974 8.91177 10.7625 8.91177C9.3744 8.91177 7.9151 9.71505 7.1826 10.7708C6.93326 11.1301 6.44225 11.2176 6.08589 10.9662C5.72953 10.7148 5.64277 10.2196 5.8921 9.86029C6.91592 8.38469 8.85445 7.32353 10.7625 7.32353ZM13.125 4.14706C13.125 2.68513 11.9497 1.5 10.5 1.5C9.05025 1.5 7.875 2.68513 7.875 4.14706V5.07837C4.36825 6.19396 1.8375 9.50557 1.8375 13.4118C1.8375 13.8504 2.19008 14.2059 2.625 14.2059L11.55 14C11.55 9.5 19 12.9386 19 12.5C19 8.60495 16.6192 6.21913 13.125 5.09159V4.14706ZM9.45 4.14706C9.45 3.56229 9.9201 3.08824 10.5 3.08824C11.0799 3.08824 11.55 3.56229 11.55 4.14706V4.7428C11.1984 4.69903 10.8405 4.67649 10.4775 4.67649C10.1297 4.67649 9.78683 4.69716 9.45 4.73735V4.14706ZM17.5 11.5H12.5L12 12.6177H10.7625H3.45547C3.84485 9.04267 6.83292 6.26472 10.4775 6.26472C14.1272 6.26472 17.1055 7.9296 17.5 11.5ZM11.55 15.2647C12.7098 15.2647 11.9994 15.8305 11.9994 17C11.9994 18.1695 13.1598 19.5 12 19.5H2.1C0.940203 19.5 0 18.5519 0 17.3824C0 16.2128 0.940201 15.2647 2.1 15.2647H11.55ZM11.4188 17.9118C11.4188 17.6194 12.2899 16.5 12 16.5L2.1 16.8529C1.81005 16.8529 1.575 17.09 1.575 17.3824C1.575 17.6747 1.81005 17.9118 2.1 17.9118H11.4188C4.04625 17.8694 11.4188 18.9053 11.4188 17.9118Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.117V12.5C12 12.2239 12.2239 12 12.5 12H19.9658C20.2419 12 20.4658 12.2239 20.4658 12.5V17.117C20.4658 19.3261 18.6749 21.117 16.4658 21.117H16C13.7909 21.117 12 19.3261 12 17.117Z",
    strokeWidth: 1.5
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4668 13.3021H21.9172C22.5548 13.3021 23.0716 13.8189 23.0716 14.4565V14.9301C23.0716 16.3687 21.9054 17.535 20.4668 17.535V17.535",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "caja fuerte",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 21C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27977 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3L7.8 3C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8L3 16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7316 13.1947C13.661 12.9831 13.6257 12.8772 13.6276 12.7907C13.6295 12.6996 13.6417 12.6519 13.6836 12.5711C13.7235 12.4942 13.83 12.395 14.0432 12.1967C14.6318 11.6489 15 10.8675 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 10.8675 9.36818 11.649 9.95681 12.1967C10.17 12.395 10.2765 12.4942 10.3164 12.5711C10.3583 12.6519 10.3705 12.6996 10.3724 12.7907C10.3743 12.8772 10.339 12.9831 10.2684 13.1947L9.35099 15.947C9.23249 16.3025 9.17324 16.4803 9.20877 16.6218C9.23987 16.7456 9.31718 16.8529 9.42484 16.9216C9.54783 17 9.7352 17 10.1099 17H13.8901C14.2648 17 14.4522 17 14.5752 16.9216C14.6828 16.8529 14.7601 16.7456 14.7912 16.6218C14.8268 16.4803 14.7675 16.3025 14.649 15.947L13.7316 13.1947Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "centro de negocios",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7H4C2.89543 7 2 7.89543 2 9V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V9C22 7.89543 21.1046 7 20 7Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21V5C16 4.46957 15.7893 3.96086 15.4142 3.58579C15.0391 3.21071 14.5304 3 14 3H10C9.46957 3 8.96086 3.21071 8.58579 3.58579C8.21071 3.96086 8 4.46957 8 5V21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "camarera",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47481 20.3736L12.3061 21.5162C12.4448 21.5434 12.5867 21.5274 12.709 21.4706L18.6057 18.7344C19.2892 18.4172 19.5308 17.6352 19.1454 16.9877V16.9877C18.7601 16.3402 17.8935 16.0724 17.21 16.3896L12.1708 18.728",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3395 18.6913L11.4976 18.9052C11.6329 18.9302 11.7709 18.9138 11.8899 18.8585L11.9208 18.8442C12.0843 18.7683 12.1901 18.6193 12.2019 18.448V18.448C12.2625 17.5686 11.5735 16.7548 10.6192 16.5786L9.59344 16.3892C9.13871 16.3052 8.6752 16.3604 8.27505 16.5461L5.07899 18.0291",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 20,
    height: 2,
    rx: 1,
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3C17.6421 3 21 5.98477 21 9.66667C21 10.4533 20.292 11 19.5054 11H7.4946C6.70795 11 6 10.4533 6 9.66667C6 5.98477 9.35786 3 13.5 3Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 3H12.6C12.2686 3 12.002 2.72966 12.0708 2.40549C12.1958 1.81594 12.542 1 13.5 1C14.458 1 14.8042 1.81594 14.9292 2.40549C14.998 2.72966 14.7314 3 14.4 3Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "multiling\\xFCe",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12H21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 3C14.2515 5.46452 15.5309 8.66283 15.6004 12C15.5309 15.3372 14.2515 18.5355 12.0004 21C9.74924 18.5355 8.46991 15.3372 8.40039 12C8.46991 8.66283 9.74924 5.46452 12.0004 3Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.184738334df5c908c1c032021c9183d9.svg";
export { ForwardRef as ReactComponent };